if (!customElements.get('ftw-steps')) {
  class FtwSteps extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    stepChanges (step, index) {
      const stepSettings = step.getBoundingClientRect();
      const stepBottom = stepSettings.top - window.innerHeight + stepSettings.height / 2;
      if (stepBottom < 0) {
        step.style.opacity = 1;
      } else {
        step.style.opacity = 0;
      }
      let stepPath = step.querySelector(".ftw-step--border");
      let pathHeight = ((stepBottom * -1) / stepSettings.height) * 100;
      pathHeight = pathHeight > 100 ? 100 : pathHeight;
      pathHeight = pathHeight < 0 ? 0 : pathHeight;

      stepPath.style.height = "" + pathHeight + "%";
    }

    onScrollHandler () {
      this.settings.steps.forEach((step, index) => {
        this.stepChanges(step, index);
      });
    }

    init () {
      this.settings = {
        steps: this.querySelectorAll(".ftw-step")
      };
      window.addEventListener('scroll', this.onScrollHandler.bind(this), false);
    }
  }

  customElements.define('ftw-steps', FtwSteps);
}
